import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';

@Component({ name: 'Profession' })
export default class Profession extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private profession: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.profession = this.value;
    }

    this.options = await DictApi.getProfessionType();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    this.profession = val;
  }

  public onValidator(): boolean {
    if (this.profession === undefined || this.profession === null) {
      this.errorMsg = '请选择职业';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeProfession(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="职业"
        errorMessage={this.errorMsg}
        >
        <SelectInput
          v-model={this.profession}
          title="选择职业"
          placeholder="选择职业"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeProfession}
        />
      </Field>
    );
  }
}
